var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticStyle: { width: "50%" } }, [
    _c(
      "div",
      { staticClass: "has-float-label lineInput mb-20 flex-between-center" },
      [
        _c("input", {
          ref: "searchbox",
          staticClass: "form-item",
          attrs: { id: "searchbox", type: "text", placeholder: " " },
        }),
        _vm._v(" "),
        _c(
          "label",
          { staticClass: "color-bo-s2", attrs: { for: "searchbox" } },
          [_vm._v("Tester une adresse")]
        ),
        _vm._v(" "),
        _c("i", { staticClass: "fie-icon_pin color-grey1 fsize-26" }),
      ]
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }